<template functional>
  <div
    class="stick-all-corners"
    :class="$style.inPlayerOverlay"
  >
    <div />
    <slot />
    <div class="text-center">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  functional: true,
  props: {
    transparentBackground: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" module>
.inPlayerOverlay {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
